<template>
  <div class="productview-container" v-if="this.getCurrentItemEdit">
    <FloatingHeader :title="getCurrentItemEdit?.productName" :sbtitle="formatMoney(totalPrice / (getCurrentItemEdit?.quantity || 1))"     :showHeader="true"
    :hideSearch="true" :toClear="'updateCurrentItemEdit'"
    :routeToBack="getCurrentItemEdit.edited ? 'cart' : !isFullApp ? 'cart' : 'event'"
    ></FloatingHeader>

    <!-- isFullApp ? 'cart' : 'event foi uma solucao paliativa para a demanda sodexo -->

    <div class="item-details">
      <img :src="getMockImage(getCurrentItemEdit) || getCurrentItemEdit?.productImages.large || noImgSrc"
        :alt="getCurrentItemEdit?.productName">
      <span class="pc-price" v-text="formatMoney(totalPrice)"></span>
      <span class="pd-desc" v-text="getCurrentItemEdit?.productDescription"></span>
    </div>
    <div class="observations-group" v-if="getCurrentItemEdit?.observationsChoice">
      <div class="observations-container" v-for="(obc, key) in getCurrentItemEdit.observationsChoice" :key="key">
        <span class="grupo-op-name">
          <span v-text="getProductLanguage(obc, 'obsGroupName')"></span>
          <span
            v-text="`${getCurrentItemEdit.observations.length || 0} / ${getCurrentItemEdit.observationsChoice[key].maxQuantity || (obc.observations || []).length}`"></span>
        </span>
        <div class="obs-item-container">
          <div class="item-obs" v-for="(obs, key2) in obc.observations" :key="key2">
            <label :for="key + obs.obsCode">
              <span v-text="getProductLanguage(obs, 'obsName')"></span>
              <span class="obs-price" v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
            </label>
            <div class="container-input">
              <input class="styled-input" :id="key + obs.obsCode" type="checkbox" :value="obs"
                v-model="getCurrentItemEdit.observations" @change="validateObs(obs, $event)">
              <span class="checkmark"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="combo-component">
      <AdcComp v-for="(combo, key) in getCurrentItemEdit.productGroups" :key="'wizard-step-key-' + key" :id="key"
        :combo="combo" :chosen="getCurrentItemEdit.productComboRaw && getCurrentItemEdit.productComboRaw[key]"
        :fatherProdCode="getCurrentItemEdit.productCode" :fatherPrint="getCurrentItemEdit.productPrint" :depth="key"
        :curComboKey="curComboKey" :mutexData="mutexData" :isEditing="getCurrentItemEdit.edited"
        @comboOption="comboOption" @updateComboPrice="updateComboPrice" @clearSelectedMutex="clearSelectedMutex"
        @updateNextButton="updateNextButton" @openSelectMutexModal="openSelectMutexModal" :blockProds="blockProds">
      </AdcComp>
    </div>
    <div class="prod-item-footer" v-if="loaded">
      <span class="footer-quantity">
        <p>Quantidade</p>
        <QuantityControl :quantity="getCurrentItemEdit.quantity" @circleBtnRemove="decreaseQtty()"
          @circleBtnAdd="increaseQtty()"></QuantityControl>
      </span>
      <DefaultButton v-if="showAddToCartButton()"
        :text="getCurrentItemEdit.edited ? getString('confirmar_edicao') : getString('comprar')"
        @defaultBtnClick="addToCart()" :class="{ 'disabled': wait }"
        :icon="getCurrentItemEdit.edited ? null : iconCarrinho" :large="true">
      </DefaultButton>
    </div>
  </div>
</template>

<script>
import CartController from '@/assets/controllers/CartController'
import LocaleController from '@/assets/controllers/LocaleController'
import ProductController from '@/assets/controllers/ProductController'
import PromotionalCampaignsController from '@/assets/controllers/PromotionalCampaignsController'
import eventModule from '@/assets/libs/eventModule'
import Util from '@/assets/libs/util.js'
import AdcComp from '@/components/AdcComp'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import FloatingHeader from '@/components/FloatingHeader'
import QuantityControl from '@/components/QuantityControl.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductView',
  components: {
    FloatingHeader,
    AdcComp,
    DefaultButton,
    QuantityControl
  },
  data () {
    return {
      inputElement: null,
      editingObs: false,
      input: null,
      noImageSrc: null,
      curProd: null,
      treatedComboItems: [],
      hasToPickOptions: false,
      itensLeft: 0,
      curComboKey: 0,
      mutexData: null,
      mutexDataBkp: null,
      blockProds: [],
      useAlternativeLayout: true,
      alternativeLayoutCounter: 1,
      wizardStepInEvidence: 0,
      enabledNextButton: false,
      calledOnMounted: false,
      preventShaking: false,
      goingForward: true,
      exibeObsDigitada: false,
      typedObs: '',
      showSelectMutexModal: false,
      groupsData: [],
      totalPrice: 0,
      wait: false,
      oldProductGroup: null,
      showText: false,
      loaded: false,
      junk: '',
      arrow_back_white: '',
      enableJumpGroup: true,
      iconCarrinho: require('../../static/icons/btn-carrinho.svg'),
      editProduct: false, // temporário,
      redirectToCart: false,
      noImgSrc: require('@/assets/mock/prodImg/placeholder.svg')
    }
  },
  computed: {
    ...mapGetters(['getCurrentItemEdit', 'isFullApp'])
  },
  mounted () {
    if (!this.getCurrentItemEdit) {
      this.$router.push('/')
      return false
    }
    this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
    // this.getCurrentItemEdit = this.getCurrentItemEdit
    this.blockProds = Util.getLocalVar('blockProds')
    this.exibeObsDigitada = Util.getLocalConfigs('permiteObsDigitada') && this.isSimpleProduct()

    if (this.exibeObsDigitada) {
      this.typedObs = this.getCurrentItemEdit.typedObs ? this.getCurrentItemEdit.typedObs : ''
    }

    this.mutexData = this.getCurrentItemEdit.mutexData ? this.getCurrentItemEdit.mutexData : this.buildMutexData()
    this.mutexDataBkp = Util.deepCopy(this.mutexData)
    this.getCurrentItemEdit.productGroups.forEach(p => delete p.listed)
    this.getCurrentItemEdit.productComboBkp = this.getCurrentItemEdit.productCombo ? Util.deepCopy(this.getCurrentItemEdit.productCombo) : []
    this.getCurrentItemEdit.observationsBkp = this.getCurrentItemEdit.observations ? Util.deepCopy(this.getCurrentItemEdit.observations) : []
    this.getCurrentItemEdit.productGroupsBkp = this.getCurrentItemEdit.productGroups ? Util.deepCopy(this.getCurrentItemEdit.productGroups) : []
    this.getCurrentItemEdit.productComboRawBkp = this.getCurrentItemEdit.productComboRaw ? Util.deepCopy(this.getCurrentItemEdit.productComboRaw) : []

    if (this.getCurrentItemEdit && this.getCurrentItemEdit.productCode) {
      this.getCurrentItemEdit.quantity = this.getCurrentItemEdit.quantity || 1
      this.getCurrentItemEdit.totalItemPrice = this.getCurrentItemEdit.edited && this.getCurrentItemEdit ? parseFloat(this.getCurrentItemEdit.totalItemPrice) : parseFloat(this.getCurrentItemEdit.price)

      this.getCurrentItemEdit.observations = this.getCurrentItemEdit.edited && this.getCurrentItemEdit ? this.getCurrentItemEdit.observations : []
      this.getCurrentItemEdit.observationsChoice && this.getCurrentItemEdit.observationsChoice.forEach(obc => {
        (obc.observations || []).forEach(obs => {
          obs.obsGroupCode = obc.obsGroupCode
        })
      })

      // Se o usuário entrou nesta tela para editar um produto, este bloco atualiza as quantidades no
      // array observationsChoice de acordo com as quantidades no array observations, caso necessário
      if (this.getCurrentItemEdit.observations.length > 0) {
        this.getCurrentItemEdit.observations.forEach(obs => {
          if (obs.quantity !== undefined && obs.quantity > 0) {
            for (let i = 0; i < this.getCurrentItemEdit.observationsChoice.length; i++) {
              const obsIndex = this.getCurrentItemEdit.observationsChoice[i].observations.findIndex(element => {
                return element.obsCode === obs.obsCode &&
                  element.obsGroupCode === obs.obsGroupCode &&
                  element.obsName === obs.obsName &&
                  element.price === obs.price
              })
              if (obsIndex !== -1) {
                this.getCurrentItemEdit.observationsChoice[i].observations[obsIndex].quantity = obs.quantity
              }
            }
          }
        })
      }

      this.getCurrentItemEdit.productCombo = (this.getCurrentItemEdit.edited && this.getCurrentItemEdit) ? this.getCurrentItemEdit.productCombo : []
    } else {
      this.cancel()
    }

    if (!this.isSimpleProduct()) {
      this.updateNextButton()
      this.handleFirstGroupMutexCase()
    }
    this.updateComboPrice()
    eventModule.emit('updateButtonCart', false)
    setTimeout(() => {
      this.loaded = true
    }, 500)

    this.redirectToCart = this.$route.query?.redirectToCart || false
  },
  methods: {
    ...mapActions(['updateCurrentItemEdit']),
    getMockImage (prod) {
      try {
        return require(`@/assets/mock/prodImg/${prod.productCode}.png`)
      } catch (error) {
        return null
      }
    },
    getString: function (key) {
      return LocaleController.getString(key)
    },
    showPrice: function () {
      const showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
      return (this.getCurrentItemEdit.productPrint === 'S' && !showMinPriceDifference) || this.getCurrentItemEdit.productGroups.length === 0
    },
    isSlimMode: function () {
      return Util.isSlimMode()
    },
    accept: function (text) {
      this.hide()
    },
    show: function (e) {
      if (!Util.isAndroidMode()) {
        this.input = e.target

        if (!this.visible) {
          this.visible = true
        }

        const container = document.getElementById('page-container')
        setTimeout(() => {
          container.scrollTo(0, container.scrollHeight)
        }, 100)
      }
    },
    hide: function () {
      this.visible = false
    },
    clearSelectedMutex: function (productGroupMutex) {
      const newMutexData = Util.deepCopy(this.mutexData)
      newMutexData[productGroupMutex].selectedMutexCode = null
      this.mutexData = newMutexData
    },
    buildMutexData: function () {
      const mutexData = {}

      this.getCurrentItemEdit.productGroups.forEach((group, index) => {
        if (group.productGroupMutex && group.productGroupMutex !== null) {
          if (!mutexData[group.productGroupMutex]) {
            mutexData[group.productGroupMutex] = {
              groups: [],
              selectedMutexCode: null,
              alternativeLayoutPickedGroupIndex: null
            }
          }
          mutexData[group.productGroupMutex].groups.push({
            productGroupName: group.productGroupName,
            productGroupCode: group.productGroupCode,
            productGroupIndex: index
          })
        }
      })

      const mutexKeys = Object.keys(mutexData)
      mutexKeys.forEach(key => {
        // Se o grupo mutex contiver apenas um grupo de produtos, ele não precisa ser tratado como mutex
        if (mutexData[key].groups.length < 2) {
          delete mutexData[key]
        }
      })

      return mutexData
    },
    getImagesURL: function () {
      return Util.getLocalConfigs('urlIMGOdhenInterface')
    },
    formatMoney: function (price) {
      return Util.formatMoney(price)
    },
    validateObs: function (obs, clickEvent) {
      const obsGroup = this.getCurrentItemEdit.observationsChoice.find(element => element.obsGroupCode === obs.obsGroupCode)
      const maxObservations = obsGroup.maxQuantity
      let groupSelectedObs = []

      if (this.getCurrentItemEdit.observations && (maxObservations !== 1) && this.getCurrentItemEdit.observations.length) {
        groupSelectedObs = this.getCurrentItemEdit.observations.filter(element => element.obsGroupCode === obs.obsGroupCode)
      } else if (this.getCurrentItemEdit.observations && maxObservations === 1) {
        groupSelectedObs.push(this.getCurrentItemEdit.observations)
        this.getCurrentItemEdit.observations = [this.getCurrentItemEdit.observations]
      }

      const groupObsNumber = (groupSelectedObs && groupSelectedObs.length) || 0

      if ((maxObservations != null && maxObservations !== 0) && groupObsNumber > maxObservations && clickEvent.srcElement.checked) {
        this.getCurrentItemEdit.observations.pop()
        clickEvent.srcElement.checked = false
      }
      // this.priceUpdate()
      this.updateComboPrice()
      // this.$forceUpdate()
    },
    priceUpdate: function () {
      ProductController.priceUpdate(this.getCurrentItemEdit)
      this.$forceUpdate()
    },
    cancel: function () {
      this.getCurrentItemEdit.productCombo = Util.deepCopy(this.getCurrentItemEdit.productComboBkp)
      this.getCurrentItemEdit.productGroups = Util.deepCopy(this.getCurrentItemEdit.productGroupsBkp)
      this.getCurrentItemEdit.productComboRaw = Util.deepCopy(this.getCurrentItemEdit.productComboRawBkp)
      this.getCurrentItemEdit.observations = Util.deepCopy(this.getCurrentItemEdit.observationsBkp)
      this.getCurrentItemEdit.mutexData = Util.deepCopy(this.mutexDataBkp)
      this.priceUpdate()
      this.finish(false)
    },
    finish: function (addToCart = true) {
      if (addToCart) {
        if (this.getCurrentItemEdit.edited) {
          // console.log('editProduct prod view', this.getCurrentItemEdit)
          CartController.editProduct(this.getCurrentItemEdit)
          Util.showSuccessNotification({ title: 'Produto editado com sucesso', text: null })
          this.$router.push('/cart')
        } else {
          CartController.addToCart(this.getCurrentItemEdit)
          Util.showSuccessNotification({ title: 'Produto adicionado ao carrinho', text: null })
          if (this.redirectToCart) {
            this.$router.push('/cart')
          } else {
            this.$router.push('/event')
          }
        }
      }
      setTimeout(() => {
        const elements = document.querySelectorAll('.cart_item_container')
        if (elements && elements.length) {
          const index = elements.length - 1
          const element = elements[index]
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        }
      }, 800)
      this.$emit('closeProductItem')
      // eventModule.emit('updateCart')
      eventModule.emit('updateButtonCart', true)
      this.$forceUpdate()
    },
    addToCart: function () {
      this.itensLeft = this.getCurrentItemEdit.productGroups.length
      this.hasToPickOptions = false
      this.getCurrentItemEdit.productCombo = []
      this.getCurrentItemEdit.productComboRaw = this.getCurrentItemEdit.productComboRaw || []

      // this.getCurrentItemEdit.productComboRaw.forEach(c => {
      //     if (c != null) this.getCurrentItemEdit.productCombo = this.getCurrentItemEdit.productCombo.concat(c)
      // })
      const filteredProductComboRaw = this.getCurrentItemEdit.productComboRaw.filter(c => c != null).map(c => c)
      this.getCurrentItemEdit.productCombo = [...this.getCurrentItemEdit.productCombo, ...filteredProductComboRaw].flat(1)

      const escholhaCorrente = this.getCurrentItemEdit.productComboRaw
      const comboCorrente = this.getCurrentItemEdit.productGroups
      let carrinhoPronto = true
      const mutexData = this.mutexData
      const self = this

      comboCorrente.reverse().forEach(function (product, i) {
        const isMutex = product.productGroupMutex && mutexData[product.productGroupMutex] != null
        const hasSelectedMutex = mutexData[product.productGroupMutex] && mutexData[product.productGroupMutex].selectedMutexCode != null
        const isSelectedMutex = isMutex && mutexData[product.productGroupMutex].selectedMutexCode === product.productGroupCode

        if (product.productGroupMin > 0 && !escholhaCorrente[comboCorrente.length - (i + 1)] && (!isMutex || !hasSelectedMutex || isSelectedMutex)) {
          carrinhoPronto = false
          const errorMessage = self.getString('voce_precisa_selecionar_algum') + product.productGroupName
          Util.showErrorNotification({ title: errorMessage, text: null })
        } else if (escholhaCorrente[comboCorrente.length - (i + 1)] && (!isMutex || !hasSelectedMutex || isSelectedMutex)) {
          let totalGroupSelected = 0
          escholhaCorrente[comboCorrente.length - (i + 1)].forEach(product => {
            totalGroupSelected += product.quantity ? product.quantity : 1
          })
          if (totalGroupSelected < product.productGroupMin) {
            carrinhoPronto = false
            const errorMessage = self.getString('voce_precisa_selecionar_algum') + product.productGroupName
            Util.showErrorNotification({ title: errorMessage, text: null })
          }
        }
      })
      comboCorrente.reverse()
      if (carrinhoPronto) {
        this.getCurrentItemEdit.mutexData = this.mutexData

        if (this.exibeObsDigitada) {
          this.getCurrentItemEdit.typedObs = this.typedObs.trim()
        }
        this.wait = true
        PromotionalCampaignsController.updatePricesPromotionalCampaigns(this.getCurrentItemEdit).then(() => {
          this.wait = false
          this.priceUpdate()
          this.finish()
        })
        // this.priceUpdate()
        // this.finish()
      }
    },
    decreaseQtty: function () {
      if (this.getCurrentItemEdit.quantity > 1) {
        this.getCurrentItemEdit.quantity -= 1
      }
      this.updateComboPrice()
      // this.$forceUpdate()
    },
    increaseQtty: function () {
      this.getCurrentItemEdit.quantity += 1
      this.updateComboPrice()
      // this.$forceUpdate()
    },
    decreaseObservationQtty: function (key, key2) {
      if (this.getCurrentItemEdit.observationsChoice[key].observations[key2].quantity > 0) {
        const obsIndex = this.getCurrentItemEdit.observations.findIndex(obs => {
          return obs.obsCode === this.getCurrentItemEdit.observationsChoice[key].observations[key2].obsCode &&
            obs.obsGroupCode === this.getCurrentItemEdit.observationsChoice[key].observations[key2].obsGroupCode &&
            obs.obsName === this.getCurrentItemEdit.observationsChoice[key].observations[key2].obsName &&
            obs.price === this.getCurrentItemEdit.observationsChoice[key].observations[key2].price &&
            obs.quantity === this.getCurrentItemEdit.observationsChoice[key].observations[key2].quantity
        })

        this.getCurrentItemEdit.observations[obsIndex].quantity -= 1
        this.getCurrentItemEdit.observationsChoice[key].observations[key2].quantity -= 1
        if (this.getCurrentItemEdit.observations[obsIndex].quantity === 0) {
          this.getCurrentItemEdit.observations.splice(obsIndex, 1)
        }

        this.priceUpdate()
        this.$forceUpdate()
      }
    },
    increaseObservationQtty: function (key, key2) {
      if (this.getCurrentItemEdit.observationsChoice[key].observations[key2].quantity === 0) {
        this.getCurrentItemEdit.observationsChoice[key].observations[key2].quantity += 1
        const observationCopy = Util.deepCopy(this.getCurrentItemEdit.observationsChoice[key].observations[key2])
        this.getCurrentItemEdit.observations.push(observationCopy)
      } else {
        const obsIndex = this.getCurrentItemEdit.observations.findIndex(obs => {
          return obs.obsCode === this.getCurrentItemEdit.observationsChoice[key].observations[key2].obsCode &&
            obs.obsGroupCode === this.getCurrentItemEdit.observationsChoice[key].observations[key2].obsGroupCode &&
            obs.obsName === this.getCurrentItemEdit.observationsChoice[key].observations[key2].obsName &&
            obs.price === this.getCurrentItemEdit.observationsChoice[key].observations[key2].price &&
            obs.quantity === this.getCurrentItemEdit.observationsChoice[key].observations[key2].quantity
        })
        this.getCurrentItemEdit.observations[obsIndex].quantity += 1
        this.getCurrentItemEdit.observationsChoice[key].observations[key2].quantity += 1
      }

      this.priceUpdate()
      this.$forceUpdate()
    },
    comboOption: function (comboItemChoices) {
      this.getCurrentItemEdit.productComboRaw = this.getCurrentItemEdit.productComboRaw || []
      // Cada item filho precisa levar a referência de imprime sim/não do grupo ao qual pertence
      const groupPrint = this.getCurrentItemEdit.productGroups[comboItemChoices.key].productGroupPrint
      comboItemChoices.option.forEach(item => {
        item.groupPrint = groupPrint
      })
      this.getCurrentItemEdit.productComboRaw[comboItemChoices.key] = comboItemChoices.option

      // Trata as informações de grupos Mutex, se for o caso
      const mutexCode = this.getCurrentItemEdit.productGroups[comboItemChoices.key].productGroupMutex
      const isMutexGroup = mutexCode && this.mutexData[mutexCode]

      if (isMutexGroup) {
        const newMutexData = Util.deepCopy(this.mutexData)

        if (comboItemChoices.option.length > 0) {
          newMutexData[mutexCode].selectedMutexCode = this.getCurrentItemEdit.productGroups[comboItemChoices.key].productGroupCode
        } else {
          newMutexData[mutexCode].selectedMutexCode = null
        }

        this.mutexData = newMutexData
      }

      const groupKey = comboItemChoices.key
      const groupMaxItems = this.getCurrentItemEdit.productGroups[groupKey].productGroupMax
      let groupSelectedItems = 0
      comboItemChoices.option.forEach(prod => {
        groupSelectedItems += prod.quantity || 1
      })
      this.getCurrentItemEdit.productGroups[comboItemChoices.key].isVisible = true
      this.updateComboPrice()
      this.updateNextButton()
      if ((groupSelectedItems === groupMaxItems) && this.enableJumpGroup && this.enabledNextButton && !this.showAddToCartButton()) {
        this.nextWizardStep()
      }
      // this.updateComboPrice()
      this.$forceUpdate()
    },
    showAddToCartButton: function () {
      // return this.showingLastWizardStep() || this.isSimpleProduct()
      return true // temporario
    },
    showingLastWizardStep: function () {
      const isTheLastGroup = this.getCurrentItemEdit.productGroups && this.getCurrentItemEdit.productGroups.length === this.wizardStepInEvidence + 1
      return isTheLastGroup || !this.hasGroupAfterCurrentMutex()
    },
    hasGroupAfterCurrentMutex: function () {
      const thisGroup = this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence]
      const isMutex = thisGroup && thisGroup.productGroupMutex && this.mutexData[thisGroup.productGroupMutex] != null

      if (isMutex) {
        const groups = this.getCurrentItemEdit.productGroups || []
        let hasGroupAfter = false

        for (let i = this.wizardStepInEvidence + 1; i < groups.length; i++) {
          const group = groups[i]
          if (group.productGroupMutex !== thisGroup.productGroupMutex) {
            hasGroupAfter = true
            break
          }
        }

        return hasGroupAfter
      } else {
        return true
      }
    },
    showCancelButton: function () {
      return this.wizardStepInEvidence === 0 || !this.hasGroupBeforeCurrentMutex()
    },
    hasGroupBeforeCurrentMutex: function () {
      const thisGroup = this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence]
      const isMutex = thisGroup && thisGroup.productGroupMutex && this.mutexData[thisGroup.productGroupMutex] != null

      if (isMutex) {
        const groups = this.getCurrentItemEdit.productGroups || []
        let hasGroupBefore = false

        for (let i = this.wizardStepInEvidence - 1; i >= 0; i--) {
          const group = groups[i]
          if (group.productGroupMutex !== thisGroup.productGroupMutex) {
            hasGroupBefore = true
            break
          }
        }

        return hasGroupBefore
      } else {
        return true
      }
    },
    updateNextButton: function () {
      if (this.getCurrentItemEdit.productComboRaw != null || this.firstGroupIsOptional()) {
        this.checkNextButton()
      }
    },
    firstGroupIsOptional: function () {
      try {
        return this.getCurrentItemEdit.productGroups[0].productGroupMin === 0
      } catch (error) {
        return false
      }
    },
    checkNextButton: function () {
      const currentGroup = this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence]
      const minForCurrentGroup = currentGroup.productGroupMin
      const groupPickedProds = (this.getCurrentItemEdit.productComboRaw && this.getCurrentItemEdit.productComboRaw[this.wizardStepInEvidence])
        ? this.getCurrentItemEdit.productComboRaw[this.wizardStepInEvidence]
        : []
      let pickedFromCurrentGroup = 0

      groupPickedProds.forEach(prod => {
        pickedFromCurrentGroup += prod.quantity || 1
      })

      if (pickedFromCurrentGroup >= minForCurrentGroup) {
        this.enableNextButton()
      } else {
        this.disableNextButton()
      }
    },
    enableNextButton: function () {
      this.enabledNextButton = true
      this.$forceUpdate()
    },
    disableNextButton: function () {
      this.preventShaking = false
      this.enabledNextButton = false
    },
    previousWizardStep: function () {
      this.goingForward = false
      const previousGroup = this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence - 1]
      const previousGroupIsMutex = previousGroup.productGroupMutex && this.mutexData[previousGroup.productGroupMutex] != null

      if (previousGroupIsMutex) {
        const mutexKey = previousGroup.productGroupMutex
        const pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex

        if (this.wizardStepInEvidence !== pickedGroupIndex) {
          this.alternativeLayoutCounter--
          this.wizardStepInEvidence = pickedGroupIndex
          this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence].isVisible = true
          setTimeout(() => {
            const element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
            document.getElementById(`curProd-${this.wizardStepInEvidence}`).scrollIntoView({ behavior: 'smooth', block: 'start' })
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }, 600)
        } else {
          this.goToPreviousNotMutex(mutexKey)
        }
      } else {
        this.alternativeLayoutCounter--
        this.wizardStepInEvidence--
        this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence].isVisible = true
        setTimeout(() => {
          const element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
          if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 600)
      }

      this.preventShaking = true
      this.checkNextButton()
    },
    nextWizardStep: function (calledOnMounted = false) {
      this.goingForward = true
      if (this.enabledNextButton || calledOnMounted) {
        const nextGroup = this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence + 1]
        const nextGroupIsMutex = nextGroup.productGroupMutex && this.mutexData[nextGroup.productGroupMutex] != null
        if (nextGroupIsMutex) {
          const mutexKey = nextGroup.productGroupMutex
          const alreadyPickedMutexGroup = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex != null

          if (alreadyPickedMutexGroup) {
            const pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex

            if (this.wizardStepInEvidence !== pickedGroupIndex) {
              if (!calledOnMounted) this.alternativeLayoutCounter++
              this.wizardStepInEvidence = pickedGroupIndex
              setTimeout(() => {
                const element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }, 600)
            } else if (!calledOnMounted) {
              this.goToNextNotMutex(mutexKey)
            }
          } else {
            this.openSelectMutexModal(mutexKey)
          }
        } else {
          this.alternativeLayoutCounter++
          this.wizardStepInEvidence++
          setTimeout(() => {
            const element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }, 600)
        }
        setTimeout(() => {
          eventModule.emit('checkNextPreselect', this.wizardStepInEvidence)
          this.checkNextButton()
        }, 800)
      }
    },
    goToNextNotMutex: function (mutexKey) {
      const groups = this.getCurrentItemEdit.productGroups || []

      for (let i = this.wizardStepInEvidence; i < groups.length; i++) {
        const currentGroup = groups[i]
        if (currentGroup.productGroupMutex !== mutexKey) {
          this.alternativeLayoutCounter++
          this.wizardStepInEvidence = i
          break
        }
        this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence].isVisible = true
      }
      setTimeout(() => {
        const element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 600)
    },
    goToPreviousNotMutex: function (mutexKey) {
      const groups = this.getCurrentItemEdit.productGroups || []

      for (let i = this.wizardStepInEvidence; i >= 0; i--) {
        const currentGroup = groups[i]
        if (currentGroup.productGroupMutex !== mutexKey) {
          this.alternativeLayoutCounter--
          this.wizardStepInEvidence = i
          break
        }
        this.getCurrentItemEdit.productGroups[this.wizardStepInEvidence].isVisible = true
      }
      setTimeout(() => {
        const element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 600)
    },
    handleFirstGroupMutexCase: function () {
      const firstGroup = this.getCurrentItemEdit.productGroups[0]
      const firstGroupIsMutex = firstGroup.productGroupMutex && this.mutexData[firstGroup.productGroupMutex] != null

      if (firstGroupIsMutex) {
        const mutexKey = firstGroup.productGroupMutex
        const calledOnMounted = true
        this.openSelectMutexModal(mutexKey, calledOnMounted)
      }
    },
    openSelectMutexModal: function (mutexKey, calledOnMounted = false, oldProductGroupCode) {
      this.oldProductGroup = oldProductGroupCode
      this.buildGroupsData(mutexKey)
      this.calledOnMounted = calledOnMounted
      this.showSelectMutexModal = true
    },
    closeSelectMutexModal: function () {
      this.showSelectMutexModal = false
    },
    pickMutexGroup: function (selectedGroupIndex, mutexKey, calledOnMounted, oldProductGroupIndex) {
      const firstTimePicked = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex == null
      this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex = selectedGroupIndex
      if (firstTimePicked) {
        this.nextWizardStep(calledOnMounted)
      } else {
        this.changePickedMutex(mutexKey, oldProductGroupIndex)
      }
    },
    changePickedMutex: function (mutexKey, oldProductGroupIndex) {
      const pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex
      if (oldProductGroupIndex && (pickedGroupIndex !== oldProductGroupIndex)) {
        this.clearCurrentMutexChoices(oldProductGroupIndex)
        this.getCurrentItemEdit.productGroups[oldProductGroupIndex].isVisible = false
        setTimeout(() => {
          this.wizardStepInEvidence = pickedGroupIndex
          this.checkNextButton()
          const element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
          if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 600)
      }
    },
    clearCurrentMutexChoices: function (oldProductGroupIndex) {
      eventModule.emit('deleteAllChoices', oldProductGroupIndex)
    },
    buildGroupsData: function (mutexKey) {
      this.groupsData = []
      const groups = this.getCurrentItemEdit.productGroups || []

      groups.forEach((group, idx) => {
        const isSameMutex = group.productGroupMutex === mutexKey
        if (isSameMutex) {
          this.groupsData.push({
            name: group.productGroupName,
            index: idx,
            mutexKey: mutexKey
          })
        }
      })
    },
    jumpGroup: function (groupKey, isMutexGroup, mutexCode) {
      /* if (isMutexGroup) {
                let nextGroups = (this.getCurrentItemEdit.productGroups || []).slice(groupKey + 1)
                let nextNotMutexIndex = nextGroups.findIndex(element => element.productGroupMutex !== mutexCode)
                if (nextNotMutexIndex !== -1) {
                    let groupsToJump = groupKey + 1 + nextNotMutexIndex
                    location.hash = '#' + groupsToJump
                    eventModule.emit('checkNextPreselect', groupsToJump)
                }
            } else {
                let nextGroupHash = groupKey + 1
                let jumpToNextPreselect = this.jumpToNextPreselect(nextGroupHash)
                if (jumpToNextPreselect) nextGroupHash++
                location.hash = '#' + nextGroupHash
                eventModule.emit('checkNextPreselect', nextGroupHash)
            } */
      // this.nextWizardStep(true)
    },
    jumpToNextPreselect: function (nextGroupHash) {
      try {
        let isOptionalGroup = false
        let isFollowedByPreselec = false
        if (this.getCurrentItemEdit.productGroups && this.getCurrentItemEdit.productGroups[nextGroupHash] && this.getCurrentItemEdit.productGroups[nextGroupHash].productGroupMin === 0) {
          isOptionalGroup = true
        }
        if (this.getCurrentItemEdit.productGroups && this.getCurrentItemEdit.productGroups[nextGroupHash + 1] &&
          this.getCurrentItemEdit.productGroups[nextGroupHash + 1].productGroupMax === 1 &&
          this.getCurrentItemEdit.productGroups[nextGroupHash + 1].productGroupItems
        ) {
          const hasAnyPreselec = this.getCurrentItemEdit.productGroups[nextGroupHash + 1].productGroupItems.filter(element => element.subItemPreSelected === 'S')
          if (hasAnyPreselec) {
            isFollowedByPreselec = true
          }
        }
        return isOptionalGroup && isFollowedByPreselec
      } catch (error) {
        return false
      }
    },
    isSimpleProduct: function () {
      return (this.getCurrentItemEdit.productGroups || []).length === 0
    },
    getProductLanguage: function (product, index) {
      return LocaleController.getIndexLanguages(product, index)
    },
    updateComboPrice: function () {
      const product = Util.deepCopy(this.getCurrentItemEdit)
      product.productCombo = []
      product.productComboRaw = product.productComboRaw || []
      if (product.productComboRaw && product.productComboRaw.length > 0) {
        const filteredProductComboRaw = product.productComboRaw.filter(c => c != null).map(c => c)
        if (filteredProductComboRaw) {
          product.productCombo = [...product.productCombo, ...filteredProductComboRaw].flat(1)
        }
      }
      product.mutexData = this.mutexData
      if (this.exibeObsDigitada) {
        product.typedObs = this.typedObs.trim()
      }
      ProductController.priceUpdate(product)
      this.totalPrice = product.totalItemPrice * product.quantity
      this.$forceUpdate()
    },
    getPrice: function () {
      this.totalPrice = this.formatMoney(this.totalPrice)
    },
    editObs: function () {
      this.inputElement = this.$refs.typedObsDiv
      this.editingObs = true

      const container = document.getElementById('page-container')
      setTimeout(() => {
        container.scrollTo(0, container.scrollHeight)
      }, 100)
    },
    closeKeyboard: function () {
      this.editingObs = false
      this.typedObs = this.$refs.typedObsDiv.innerText
    },
    closeProductItem: function () {
      this.getCurrentItemEdit = null
      this.seletctedProduct = null
      this.$emit('closeProductItem')
      eventModule.emit('updateButtonCart', true)
    },
    cutText: function (text) {
      if (text.length > 100 && !this.showText) {
        return text.substring(100, 0) + '... Veja mais'
      }
      return text
    }
  }
}
</script>

<style scoped lang="less">
.productview-container {
  position: relative;
  display: block;
  padding: 65px 20px 170px 20px;

  .item-details {
    img {
      display: block;
      width: 100%;
      object-fit: contain;
      height: 300px;
    }

    .pc-price,
    .pd-desc {
      margin: 20px 0px;
      display: block;
    }

    .pc-price {
      color: var(--primaryColor);
      font-size: 24px;
      font-weight: bold;
    }

    .pd-desc {
      font-size: 12px;
    }

    .price-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      margin: 0;

      .price {
        font-size: 35px;
      }
    }
  }

  .observations-group {
    .observations-container {
      .grupo-op-name {
        grid-template-columns: calc(100% - 60px) 60px;
        background: var(--primaryColor);
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        padding: 10px 20px;
        position: relative;
        display: grid;
        font-weight: bold;

        span {
          color: #fff;
        }

        span:last-of-type {
          text-align: right;
        }
      }

      .obs-item-container {
        .item-obs {
          grid-template-columns: calc(100% - 60px) 60px;
          padding: 10px 0 10px 10px;
          display: grid;
          position: relative;
          font-size: 11px;
          font-weight: bold;
          color: #8D8D8D;
          height: 45px;

          label {
            position: relative;
            display: grid;
            grid-template-columns: 80% 20%;

            span {
              width: 100%;
              display: block;
              margin: auto;
            }
          }

          .container-input {
            position: relative;

            input {
              position: absolute;
              left: 15px;
              right: 0;
              width: 25px;
              height: 25px;
              top: 8px;
              bottom: 0;
              z-index: 1;
              opacity: 0;
            }

            .checkmark {
              position: absolute;
              bottom: 0;
              right: 0;
              left: 0;
              top: 0;
              border: solid 1px var(--primaryColor);
              width: 24px;
              height: 24px;
              border-radius: 5px;
              margin: auto;
            }

            input:checked+.checkmark {
              &:after {
                border-radius: 5px;
                content: '';
                margin: auto;
                position: absolute;
                bottom: 0;
                right: 0;
                left: 0;
                top: 0;
                width: 20px;
                height: 20px;
                background: var(--primaryColor);
              }
            }
          }

          &:not(&:last-of-type) {
            &:after {
              content: '';
              background: var(--primaryColor);
              position: absolute;
              opacity: .3;
              height: 2px;
              bottom: 0;
              right: 0;
              left: 0;
            }
          }
        }
      }
    }
  }

  .prod-item-footer {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background: white;
    bottom: 0;
    width: -webkit-fill-available;
    left: 0;
    animation: upper-in 0.4s;
    padding: 10px 0 20px 0;
    filter: drop-shadow(2px 4px 6px black);

    .footer-quantity {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 15px;
      width: 100%;

      p {
        font-size: 18px;
        color: #65696a;
      }
    }

    button {
      display: block;
      min-width: 300px !important;
      height: 55px !important;
      margin: 5px !important;
      border: none;
      background: var(--primaryColor);
      color: white;
      border-radius: 10px;
    }
  }

}
</style>
